import { Component, Input } from '@angular/core';
import { SOTProductViewModel } from '../../models';

@Component({
  selector: 'sot-productAdditionalInfo',
  templateUrl: "./productAdditionalInfo.component.html",
  styleUrls: ["productAdditionalInfo.component.scss"],
})
export class ProductAdditionalInfo {

  @Input() product: SOTProductViewModel;
  @Input() extraPrice?: number;
  @Input() toggleShowInfo: () => void;
  constructor() { }
}